import {call, put, select, take, fork} from "redux-saga/effects";
import {CODES} from "../../constants";
import {getUserInfo} from "../../reducers/app";
import {accountInfo} from "../../reducers/account";
import {applyInfo,currencyList,detailInfo} from "../../reducers/exchangeApply";
import { merchantInfo } from "../../reducers/merchant"
import API from "../../api/api";
import {toast} from "react-toastify";
import {globalIntl} from "../App/App";

export function *getCurrencyList(): Generator<any, void, any>{
	let userInfo = yield select(getUserInfo)
	let params = {
	    email: userInfo.email,
	    clientId: 'h5'
	}
	let resp = yield call(API.getCurreny, params)
	if (resp.code === CODES.SUCCESS && resp.data) {
		yield put({type: 'SET_CURRENCY_LIST', payload: resp.data})
	}
}

export function *resetExchange(){
	yield put ({type: 'RESET_APPLY_INFO'})
}

function *sellAmtChange(sellAmt:any): Generator<any, void, any>{
	let account = yield select(accountInfo)
	let detail = yield select(detailInfo)
	let merchant = yield select(merchantInfo)
	let applyAmt:number = parseFloat(sellAmt)
	let purchase:string = ''
	let sales: string = ''
	if(merchant.orgCurrency === 'JPY'){
		sellAmt = parseFloat(applyAmt.toFixed(0))
		sales = applyAmt.toFixed(0)
	} else {
		sellAmt = parseFloat(applyAmt.toFixed(2))
		sales = applyAmt.toFixed(2)
	}
	if(applyAmt < 0){
		applyAmt = 0
		sellAmt = applyAmt
		sales = applyAmt.toString()
	} else if (applyAmt > account.canWithdrawAmt) {
		applyAmt = account.canWithdrawAmt
		sellAmt = applyAmt
		sales = applyAmt.toString()
	}
	purchase = (applyAmt * detail.exchangeRate).toFixed(2)
	yield put({type: 'SET_AMT', payload: {sellAmt,sales}})
	yield put({type: 'SET_PURCHASE',payload:{purchaseAmount:purchase}})
}

function *submitExchange(): Generator<any, void, any>{
	let userInfo = yield select(getUserInfo)
	let apply = yield select(applyInfo)
	if(apply.useDefaultBankInfo === 1){
		if (apply.sellAmt === 0) {
			toast.error(globalIntl.formatMessage({id: 'sellToast'}))
		} else if (apply.buyCurrency === '') {
			toast.error(globalIntl.formatMessage({id: 'currencyToast'}))
		} else {
			let params = {
				...apply,
				sellAmt: parseFloat(apply.sellAmt),
				email: userInfo.email,
				clientId: 'h5',
				bankName: '',
				bankAccountNo: '',
				bankAccountName: '',
				bankAddress: '',
				swiftcode: '',
			}
			let resp = yield call(API.submitExchange,params)
			if (resp.code === CODES.SUCCESS) {
				toast.success(resp.msg)
				window.location.reload()
			}
		}
	} else if(apply.useDefaultBankInfo === 0){
		if(apply.bankName === '' || apply.bankAccountNo === '' || apply.bankAccountName === '' || apply.bankAddress === '' || apply.swiftcode === ''){
			toast.error(globalIntl.formatMessage({id: 'improveBankInformation'}))
		} else if (apply.sellAmt === 0) {
			toast.error(globalIntl.formatMessage({id: 'sellToast'}))
		} else if (apply.buyCurrency === '') {
			toast.error(globalIntl.formatMessage({id: 'currencyToast'}))
		} else {
			let params = {
				...apply,
				sellAmt: parseFloat(apply.sellAmt),
				email: userInfo.email,
				clientId: 'h5'
			}
			let resp = yield call(API.submitExchange,params)
			if (resp.code === CODES.SUCCESS) {
				toast.success(resp.msg)
				window.location.reload()
			}
		}
	}
}

export function *watchExchangeAmt(){
    while (true) {
        let {payload} =  yield take('AMT_CHANGE')
		yield fork(sellAmtChange,payload.sellAmt)
    }
}

export function *watchExchangeSubmit(){
    while (true) {
        yield take('SUBMIT_EXCHANGE')
		yield fork(submitExchange)
    }
}

function *cuurrencyChange(data: any): Generator<any, void, any>{
	let list = yield select(currencyList)
	let apply = yield select(applyInfo)
	let rate:number = 0
	let purchase:string = ''
	list.map((item:any,index:number) => {
		if(item.currency === data){
			rate = item.exchangeRate
			purchase = (item.exchangeRate * apply.sellAmt).toFixed(2)
		}
	})
	yield put({type: 'SET_CURRENCY', payload:{buyCurrency:data,exchangeRate:rate,purchaseAmount:purchase}})
}

export function *watchCurrencychange(){
    while (true) {
        let {payload} = yield take('CURRENCY_CHANGE')
		yield fork(cuurrencyChange,payload.buyCurrency)
    }
}